/* eslint-disable no-underscore-dangle */
import { Input } from 'antd';
import classNames from 'classnames/bind';
import { ListItem } from 'components/ui';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styles from '../index.less';
import getAddonAfter from './getAddonAfter';
import getAddonBefore from './getAddonBefore';
import mapModelToProps from './mapModelToProps';
import { deleteLocalFolder, tryCommitNewFolder, setActiveFolder, setEditingFolder, tryCommitFolderName, resetEditingFolder, tryDeleteFolder } from '../flow/actions';

const cx = classNames.bind(styles);


const defaultProps = {};
const propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  sharedBy: PropTypes.string.isRequired,
  sharedToTeams: PropTypes.array.isRequired,
  sharedToUsers: PropTypes.array.isRequired,
  isShared: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['report', 'dashboard']).isRequired,
};

class FolderItem extends Component {
  handleItemClick = (id, type) => this.props.setActiveFolder(id, type)
  handleFolderNameChange = e => this.setState({ newName: e.target.value })

  render() {
    const {
      addonBefore,
      addonAfter,
      id,
      name,
      isActive,
      isEditing,
      sharedBy,
      type,
      newName,
      onNameChange,
    } = this.props;

    return (
      <div
        className={cx('listItemWrapper')}
        onClick={() => this.handleItemClick(id, type)}
      >
        <ListItem
          addonBefore={addonBefore}
          addonAfter={addonAfter}
        >
          <div className={cx('content', { active: isActive })}>
            {isEditing ? (
              <Input
                value={newName}
                size="small"
                onChange={onNameChange}
                onClick={e => e.stopPropagation()}
              />
            ) : (
                <Fragment>
                  <span className="title">{name}</span>
                  {sharedBy && <span className={`${cx('sharedBy')} ml-sm`}>({sharedBy})</span>}
                </Fragment>
              )}
          </div>
        </ListItem>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  setActiveFolder,
  setEditingFolder,
  resetEditingFolder,
  tryCommitFolderName,
  tryDeleteFolder,
  tryCommitNewFolder,
  deleteLocalFolder,
};
FolderItem.defaultProps = defaultProps;
FolderItem.propTypes = propTypes;
const enhancers = compose(
  mapModelToProps(({ data }) => ({
    id: data._id,
    name: data._name,
    isActive: data._isActive,
    isEditing: data._isEditing,
    sharedBy: data._sharedBy,
    sharedToTeams: data._sharedToTeams,
    sharedToUsers: data._sharedToUsers,
    isShared: data._isShared,
    type: data._type,
  })),
  connect(mapStateToProps, mapDispatchToProps),
  getAddonBefore,
  getAddonAfter,
);
export default enhancers(FolderItem);



// WEBPACK FOOTER //
// ./src/views/ReportListSider/components/FolderItem.jsx